// extracted by mini-css-extract-plugin
module.exports = {"root":"Item_root__1vpsa","title":"Item_title__3mqtG","titleUnderlined":"Item_titleUnderlined__3vvUp","subtitle":"Item_subtitle__3YmwD","content":"Item_content__4AxSs"};